/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiGreetingsQueryResponse, GetApiGreetingsQueryParams, GetApiGreetings400, GetApiGreetings401, GetApiGreetings403, GetApiGreetings500 } from "../../types/GetApiGreetings.ts";
import { getApiGreetingsQueryResponseSchema } from "../../zod/GreetingsSchemas/getApiGreetingsSchema.ts";

function getGetApiGreetingsUrl() {
  const res = { method: 'GET', url: `/api/greetings` as const }  
  return res
}

/**
 * @summary Получение списка шаблонов приветственных экранов
 * {@link /api/greetings}
 */
export async function getApiGreetings({ params }: { params?: GetApiGreetingsQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiGreetingsQueryResponse, ResponseErrorConfig<GetApiGreetings400 | GetApiGreetings401 | GetApiGreetings403 | GetApiGreetings500>, unknown>({ method : "GET", url : getGetApiGreetingsUrl().url.toString(), params, ... requestConfig })  
  return getApiGreetingsQueryResponseSchema.parse(res.data)
}